import React from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';
import { deletePortaluserOrtu } from './redux/reduxApi';

const actions = {
  deletePortaluserOrtu,
  closeModal,
};

function ModalDeletePortaluser({ data, deletePortaluserOrtu, closeModal }) {
  const { auth, history, item, userId } = data;

  function handleDelete() {
    deletePortaluserOrtu({
      auth,
      history,
      values: item,
      userId: userId,
    });
    closeModal();
  }

  return (
    <Modal variant='danger' closeModal={closeModal}>
      <p className='ml-2 mt-4'>
        Apakah Anda ingin menghapus user portal{' '}
        <span className='has-text-danger has-text-weight-semibold'>{`${item.name}`}</span>
        ?
      </p>
      <div className='flex justify-end align-center pt-5'>
        <div className='buttons'>
          <Button cvariant='cdelete' onClick={handleDelete} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeletePortaluser);
